import { Component, Input } from '@angular/core';

@Component({
    selector: 'xm-whats-changing-component',
    styleUrls: ['./whats-changing-component.scss'],
    templateUrl: './whats-changing-component.html',
    standalone: false
})
export class XmWhatsChangingComponent  {
    @Input() public pageData: WhatsChanging;
}
